import { appConfig } from 'app/app.config';
import { logger, onUserConnected, onUserDisconnected } from 'common/logger/logger';
import { sgwtConnect } from 'common/sgwt/sgwtConnect';

// POLYFILL: Remove Temporal polyfill once all supported browsers have native Temporal support
// oxlint-disable-next-line import/no-unassigned-import
import 'temporal-polyfill/global';

import './assets/materialsFonts.css';
import './index.css';

/**
 * To be able on dev to simulate a close WebSocket with sockets.at(-1).close(); To combine with blocking negotiate url
 */
if (import.meta.env.DEV) {
  const sockets: WebSocket[] = [];

  const originalSend = WebSocket.prototype.send;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  WebSocket.prototype.send = function (...args) {
    if (!sockets.includes(this)) {
      sockets.push(this);
    }

    return originalSend.call(this, ...args);
  };

  // oxlint-disable-next-line typescript/no-explicit-any
  (window as any).sockets = sockets;
}

window.sgwtConnect = sgwtConnect;

sgwtConnect.on('authorizationDiscarded', onUserDisconnected);
sgwtConnect.on('authorizationExpired', onUserDisconnected);
sgwtConnect.on('renewAuthorizationError', onUserDisconnected);
sgwtConnect.on('renewAuthorizationSuccess', onUserConnected);

if (sgwtConnect.isAuthorized()) {
  onUserConnected();

  // Warning message when current tab isn't the master one
  const timeout = setTimeout(async () => {
    const { loadLockedApp } = await import('./loadLockedApp');
    loadLockedApp();
  }, 500);

  // Exclusive tab lock, others wait the primary one to die/exit
  await navigator.locks.request(`master_tab_lock${import.meta.env.DEV ? Date.now() : ''}`, async () => {
    try {
      clearTimeout(timeout);
      const { loadApp } = await import('./loadApp');
      await loadApp();
    } catch (error) {
      console.error('Lock error', error);
      logger.logError('Error while acquiring the master tab lock: {Error}', JSON.stringify(error));
    }
  });
} else {
  onUserDisconnected();

  if (sgwtConnect.getAuthorizationError()) {
    window.location.assign(appConfig.unauthorized_redirect_uri);
  } else {
    sgwtConnect.requestAuthorization();
  }
}
